import styled from '@emotion/styled';
import { Button } from '@naf-simba/elements-buttons';

export const StyledButton = styled(Button)`
  svg {
    display: inline;
    margin-left: 20px;
  }
`;
